export function updateOrCreate(
  data,
  updatedOrNewElement,
  dir = false,
  key = 'id'
) {
  if (!updatedOrNewElement) return data;

  const elementsToCheck = data.data || data;

  var newElements = [...elementsToCheck];

  const existing = newElements.find(
    (obj) => obj[key] === updatedOrNewElement[key]
  );
  if (existing) {
    newElements.forEach((element, index) => {
      if (element[key] === updatedOrNewElement[key]) {
        newElements[index] = updatedOrNewElement;
      }
    });
  } else {
    if (dir) {
      newElements.push(updatedOrNewElement);
    } else {
      newElements.unshift(updatedOrNewElement);
    }
  }

  if (data.data) {
    return { ...data, data: [...newElements] };
  }
  return [...newElements];
}
